interface OsInfo {
  name: string;
  version: string;
  hostname: string;
  machineId: string;
}

export const getOSInfo = (): OsInfo | undefined => {
  if (!window.electron?.getOSInfo) return undefined;

  return window.electron.getOSInfo();
};
